//SET LOADING STATE

export const setLoadingIndicator = (isLoading) => ({
    type : 'SET_LOADING_INDICATOR',
    isLoading
});
export const setResetIndicator = (isReset) => ({
    type : 'SET_RESET_INDICATOR',
    isReset
});


// WEBPACK FOOTER //
// ./src/Actions/loading.js